import $ from 'jquery'
import Decimal from 'decimal.js';

const classLimits = {
  'js-custom-volume-dough-field': 8,
  'js-volume-ml': 9,
  'js-product-amount': 9,
  'js-master-product-material-cost': 9,
  'js-master-product-price': 9,
  'js-deliver-order-amount': 10,
  'js-deliver-order-money': 19,
};

export function numberWithCommas(x) {
  if (x == undefined || x === "") {
    return "";
  }

  const isNegative = x.toString().startsWith("-");
  const abs = isNegative ? x.toString().slice(1) : x.toString();

  const parts = abs.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (isNegative ? "-" : "") + parts.join(".");
}

export function parseFormattedNumber(str) {
  if (!str) return 0;
  return parseFloat(str.replace(/,/g, '')) || 0;
}

export function setOrderInputFieldValue($input, value) {
  $input.val(value).trigger('input');
}

export function updateOrderSummary(is_input_surcharge = false) {
  const rawSubtotalByTaxRate = {};

  $('.nested-fields').each(function () {
    const $row = $(this);
    const amount = correctNumberFieldByFormatted($row.find('.js-order-item-amount').val());
    const price = correctNumberFieldByFormatted($row.find('.js-product-price').val());
    if (!$.isNumeric(amount) || !$.isNumeric(price)) return;

    const rawItemTotal = new Decimal(amount).mul(new Decimal(price)).toNumber();
    const taxRate = parseFloat($row.find('.js-product-tax-val').val()) || 0;
    rawSubtotalByTaxRate[taxRate] = (rawSubtotalByTaxRate[taxRate] || 0) + rawItemTotal;
  });

  const total = Math.floor(Object.values(rawSubtotalByTaxRate).reduce((s, v) => s + v, 0));
  const totalTax = Object.entries(rawSubtotalByTaxRate).reduce((sum, [rate, subtotal]) => {
    return sum + Math.floor(Math.floor(subtotal) * parseFloat(rate) / 100);
  }, 0);

  const grandTotal = total + totalTax;

  $('.js-order-total-summary').text(formatCurrencyWithYen(total));
  $('.js-order-tax-summary').text(formatCurrencyWithYen(totalTax));
  $('.js-order-grand-total-summary').text(formatCurrencyWithYen(grandTotal));
}

function formatCurrencyWithYen(value) {
  const isNegative = value < 0;
  const absValue = Math.abs(value);
  return (isNegative ? '- ' : '') + '¥' + numberWithCommas(absValue);
}

function formatFloatFieldLimit(value, maxIntegerDigits, maxDecimalPlaces = 1) {
  const cleaned = cleanFloatInput(value);

  const [intPart = '', decimalPart] = cleaned.split('.');
  let limitedInt = intPart
  if (maxIntegerDigits) {
    limitedInt = intPart.slice(0, maxIntegerDigits);
  }

  const limitedDecimal = decimalPart?.slice(0, maxDecimalPlaces);
  const result = limitedDecimal !== undefined
    ? `${limitedInt}.${limitedDecimal}`
    : limitedInt;

  return numberWithCommas(result);
}

function formatAndPreserveCursor(input, formatter) {
  if (!input || typeof input.selectionStart !== 'number') {
    input.value = formatter(input.value);
    return;
  }

  const rawValue = input.value;
  const originalCursor = input.selectionStart;

  const formattedValue = formatter(rawValue);
  input.value = formattedValue;

  let digitCountBeforeCursor = 0;
  for (let i = 0; i < originalCursor; i++) {
    if (/\d/.test(rawValue[i])) digitCountBeforeCursor++;
  }

  let newCursor = formattedValue.length;
  let digitsSeen = 0;
  for (let i = 0; i < formattedValue.length; i++) {
    if (/\d/.test(formattedValue[i])) {
      digitsSeen++;
      if (digitsSeen >= digitCountBeforeCursor) {
        newCursor = i + 1;
        break;
      }
    }
  }

  requestAnimationFrame(() => {
    input.focus();
    input.setSelectionRange(newCursor, newCursor);
  });
}

function cleanFloatInput(value) {
  return value
    .replace(/(?!^-)[^0-9.]/g, '')
    .replace(/(\..*?)\..*/g, '$1');
}

$(document).on('ready turbolinks:load', function () {
  correctFormatNumberFields();
  formatVolumeFields(classLimits);
});

$(document).on('shown.bs.modal', function () {
  correctFormatNumberFields();
});

function formatFloatField(value) {
  let cleaned = cleanFloatInput(value);

  const numberAfterDot = cleaned.split('.')[1];
  if (numberAfterDot && numberAfterDot.length > 1) {
    cleaned = parseFloat(cleaned).toString();
  }

  return numberWithCommas(cleaned);
}

$(function () {
  function formatIntField(value) {
    let cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 10) {
      cleaned = cleaned.slice(0, 10);
    }
    return numberWithCommas(cleaned);
  }

  function formatAndPreserveCursor(input, formatter) {
    if (!input || typeof input.selectionStart !== 'number') {
      input.value = formatter(input.value);
      return;
    }

    const rawValue = input.value;
    const originalCursor = input.selectionStart;

    const formattedValue = formatter(rawValue);
    input.value = formattedValue;

    let digitCountBeforeCursor = 0;
    for (let i = 0; i < originalCursor; i++) {
      if (/\d./.test(rawValue[i])) digitCountBeforeCursor++;
    }

    let newCursor = formattedValue.length;
    let digitsSeen = 0;
    for (let i = 0; i < formattedValue.length; i++) {
      if (/\d./.test(formattedValue[i])) {
        digitsSeen++;
        if (digitsSeen >= digitCountBeforeCursor) {
          newCursor = i + 1;
          break;
        }
      }
    }

    requestAnimationFrame(() => {
      input.focus();
      input.setSelectionRange(newCursor, newCursor);
    });
  }

  $(document).off('input .js-format-int-field').on('input', '.js-format-int-field', function () {
    formatAndPreserveCursor(this, formatIntField);
  });

  $(document).off('input .js-format-float-field').on('input', '.js-format-float-field', function (evt) {
    formatAndPreserveCursor(this, formatFloatField);
  });

  $(document).on('blur', '.js-format-int-field-blur', function () {
    const $input = $(this);
    formatNumberField($(this), 0);

    if ($(this).hasClass('js-order-item-amount') || $(this).hasClass('js-product-price')) {
      updateOrderItemTotalFee($(this))
    }

    const isSurchargeInput = $input.hasClass('js-order-surcharge');

    if (!isSurchargeInput &&
        window.location.pathname === '/orders/new' &&
        $('#new_order').length) {
      updateOrderSummary();
    }
  });

  $(document).on('blur', '.js-format-float-field-blur', function () {
    const $input = $(this);
    formatNumberField($(this), 2);

    if ($(this).hasClass('js-order-item-amount') || $(this).hasClass('js-product-price')) {
      updateOrderItemTotalFee($(this))
    }

    const isSurchargeInput = $input.hasClass('js-order-surcharge');

    if (!isSurchargeInput &&
        window.location.pathname === '/orders/new' &&
        $('#new_order').length) {
      updateOrderSummary();
    }
  });

  $(document).on('blur', '.js-format-float-two-field-blur', function () {
    formatNumberField($(this), 2);
  });

  $(document).on('blur', '.js-format-float-three-field-blur', function () {
    formatNumberField($(this), 3);
  });

  $(document).on('input', '.js-convert-time-fullwidth-halfwidth', function () {
    const $input = $(this);
    const originalVal = $input.val();
    const convertedVal = timeToHalfWidth(originalVal);

    if (convertedVal !== originalVal) {
      const caretPos = $input[0].selectionStart;
      $input.val(convertedVal);
      $input[0].setSelectionRange(caretPos, caretPos);
    }
  });

  $(document).on('blur', '.js-convert-time-fullwidth-halfwidth', function () {
    $(this).trigger('change');
  });

  $(document).on('input', '.js-format-float-three-field', function (evt) {
    var self = $(this);

    self.val(self.val().replace(/(?!^-)[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
    if ((evt.which != 46 || self.val().indexOf('.') != -1) && (evt.which < 48 || evt.which > 57)) {
      evt.preventDefault();
    }

    var number_after_dot = self.val().toString().split('.')[1];
    if (number_after_dot && number_after_dot.toString().length > 3) {
      var current_value = self.val().toString().slice(0, -1);
      self.val(parseFloat(current_value));
    }

    $(this).val(numberWithCommas($(this).val()));
  });

  $(document).on('input', '.js-product-amount, .js-master-product-material-cost, .js-master-product-price, .js-deliver-order-amount', function () {
    const className = $(this).attr('class').split(' ').find(cls => classLimits[cls]);
    const limit = classLimits[className] || undefined;

    if ($(this).hasClass('js-master-product-price') || $(this).hasClass('js-deliver-order-amount')) {
      formatAndPreserveCursor(this, value => formatFloatFieldLimit(value, limit, 2));
    } else {
      $(this).val(sanitizeAndFormatNumber($(this).val(), limit));
    }
  });
});

function trimDecimalZeros(value, decimalPlaces = 0) {
  if (value === '' || value === null || value === undefined) return '';

  let val = String(value);
  if (decimalPlaces === 0) {
    return val.split('.')[0];
  }

  if (val.endsWith('.')) return val;
  if (/\.\d*0$/.test(val) && val.length - val.indexOf('.') - 1 < decimalPlaces) {
    return val;
  }

  if (val.includes(".")) {
    val = val.replace(/(\.\d*?[1-9])0+$/, "$1");
    val = val.replace(/\.0+$/, "");
  }

  return val;
}

export function formatNumberField(self, decimalPlaces = 0) {
  setTimeout(function () {
    let val = toHalfWidth(self.val());

    val = val.replace(/[^0-9.\-]/g, '');

    const isNegative = val.startsWith("-");
    val = val.replace(/-/g, "");
    if (isNegative) val = "-" + val;

    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    if (val.includes('.') && decimalPlaces > 0) {
      const [intPart, decimalPart] = val.split('.');
      val = intPart + '.' + (decimalPart || '').slice(0, decimalPlaces);
    } else {
      val = val.split('.')[0];
    }

    val = trimDecimalZeros(val, decimalPlaces);

    const formatted = numberWithCommas(val);
    self.val(formatted);

    if (self.hasClass('js-custom-volume-dough-field')) {
      const title = formatted
          ? `レシピ(${formatted}kgあたりの原材料)`
          : 'レシピ(1kgあたりの原材料)';
      $('.js-table-description-title').html(title);
    }
  }, 50);
}

export function updateOrderItemTotalFee($field) {
  setTimeout(function () {
    let parent = $field.closest('div.item');
    let productAmount = $(parent).find('.js-order-item-amount').val();
    let productPrice = $(parent).find('.js-product-price').val();
    let orderTotalFeeField = $(parent).find('.js-order-total-fee');

    productAmount = correctNumberFieldByFormatted(productAmount);
    productPrice = correctNumberFieldByFormatted(productPrice);

    if ($.isNumeric(productAmount) && $.isNumeric(productPrice)) {
      let item_amount_converted = new Decimal(productAmount);
      let product_price_converted = new Decimal(productPrice);
      let order_item_total_fee = item_amount_converted.mul(product_price_converted);
      let formatted_order_item_total_fee =
          order_item_total_fee % 1 === 0
              ? order_item_total_fee
              : order_item_total_fee.toString().split('.')[0];

      formatted_order_item_total_fee = parseInt(formatted_order_item_total_fee);
      let display_order_item_total_fee = numberWithCommas(formatted_order_item_total_fee);

      setOrderInputFieldValue($(orderTotalFeeField), display_order_item_total_fee);
    }
  }, 60);
}

function correctNumberFieldByFormatted(input_value, item_type) {
  if (!input_value) return "";

  let normalized = toHalfWidth(String(input_value).trim());

  normalized = normalized.replace(/,/g, '');

  return item_type === 'int' ? parseInt(normalized, 10) : parseFloat(normalized);
}


export function toHalfWidth(str) {
  if (typeof str !== 'string') return '';

  return str.replace(/[\uFF01-\uFF5E\u3000\uFF0D\u2212\u30FC\uFF70\uFF0C\uFF0E\uFF61\uFF64\u3002\u3001]/g, function (ch) {
    switch (ch) {
      case '　': return ' ';      // fullwidth space
      case '－': case '−': case 'ー': case 'ｰ': return '-'; // various dash-like chars
      case '．': case '｡': case '。': return '.'; // fullwidth period variants
      default:
        return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
    }
  });
}

function timeToHalfWidth(str) {
  if (typeof str !== 'string') return '';
  return str.replace(/[\uFF01-\uFF5E]/g, function(ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
  }).replace(/\u3000/g, " ");
}

function formatVolumeFields(classLimits) {
  Object.entries(classLimits).forEach(([className, limit]) => {
    $(`input.${className}`).each(function () {
      const $field = $(this);
      if (className == 'js-master-product-price' || className == 'js-deliver-order-amount') {
        formatAndPreserveCursor(this, value => formatFloatFieldLimit(value, limit, 2));
      } else {
        $field.val(sanitizeAndFormatNumber($field.val(), limit));
      }
    });
  });
}

function sanitizeAndFormatNumber(input, limit) {
  if (!input) return '';
  
  // Check if this is a decimal field (like deliver-order-amount)
  const isDecimalField = input.includes('.');
  
  if (isDecimalField) {
    // For decimal fields, preserve the decimal point
    let numeric = input.replace(/[^0-9.]/g, '');
    // Ensure only one decimal point
    const parts = numeric.split('.');
    if (parts.length > 2) {
      numeric = parts[0] + '.' + parts.slice(1).join('');
    }
    
    if (limit) {
      const [intPart, decimalPart] = numeric.split('.');
      const limitedInt = intPart.slice(0, limit);
      numeric = decimalPart !== undefined ? `${limitedInt}.${decimalPart}` : limitedInt;
    }
    
    return numberWithCommas(numeric);
  } else {
    // For integer fields, use the original logic
    let numeric = input.replace(/[^0-9]/g, '');
    if (limit) {
      numeric = numeric.slice(0, limit);
    }
    return numberWithCommas(numeric);
  }
}

export function correctFormatNumberFields() {
  var $js_display_formatted_number = $('.js-display-formatted-number');
  var $js_display_input_formatted_number = $('input.js-display-input-formatted-number');

  function cleanNumber(value) {
    if (value === null || value === undefined) return "";
    value = value.toString().trim();
    if (value === "") return "";
    value = value.replace(/,/g, "");
    if (isNaN(value)) return value;
    let num = parseFloat(value);
    if (isNaN(num)) return "";
    let parts = num.toString().split(".");
    let intPart = numberWithCommas(parts[0]);
    return parts.length > 1 ? intPart + "." + parts[1] : intPart;
  }

  $js_display_formatted_number.each(function () {
    var current_value = $(this).text();
    $(this).text(cleanNumber(current_value));
  });

  $js_display_input_formatted_number.each(function () {
    var current_value = $(this).val();
    $(this).val(cleanNumber(current_value));
  });
}
